export const INVESTITII_PRODUCT_DELETED_EVENT = "investitii:product-deleted";

export const normalizeInvestitiiSkuKey = (value = "") => {
  if (!value) return "";
  if (typeof value === "object") {
    return String(value.value || value.name || value.id || "").trim().toUpperCase();
  }
  return String(value).trim().toUpperCase();
};

export const emitInvestitiiProductDeleted = (product = {}) => {
  if (typeof window === "undefined") return;

  const sku = String(product.sku || "").trim();
  const productId = product.productId || product.id || null;

  window.dispatchEvent(
    new CustomEvent(INVESTITII_PRODUCT_DELETED_EVENT, {
      detail: { sku, productId },
    }),
  );
};
